module.exports = __webpack_public_path__ + "static/img/testimony (6).1b993743.jpg";